<template>
  <main-sidebar :name="name" :title="$t('preview')" size="large">
    <div class="p-4">
      <div>
        <vs-row>
          <vs-col vs-xs="12" vs-sm="8" vs-lg="8">
            <vs-input
              v-model="company.name"
              class="w-full px-2"
              :label="$t('company') | capitalize"
              disabled
            />
          </vs-col>
          <vs-col vs-xs="12" vs-sm="4" vs-lg="4">
            <vs-input
              v-model="company.rfc"
              class="w-full px-2"
              :label="$t('rfc') | capitalize"
              disabled
            />
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-xs="12" vs-sm="6" vs-lg="6">
            <vs-input
              v-model="company.address1"
              class="w-full px-2"
              :label="$t('address') | capitalize"
              disabled
            />
          </vs-col>
          <vs-col vs-xs="12" vs-sm="6" vs-lg="6">
            <vs-input
              v-model="company.address2"
              class="w-full px-2"
              :label="$t('address') | capitalize"
              disabled
            />
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-xs="12" vs-sm="5" vs-lg="5">
            <vs-input
              v-model="company.city"
              class="w-full px-2"
              :label="$t('city') | capitalize"
              disabled
            />
          </vs-col>
          <vs-col vs-xs="12" vs-sm="5" vs-lg="5">
            <vs-input
              v-model="company.state"
              class="w-full px-2"
              :label="$t('state') | capitalize"
              disabled
            />
          </vs-col>
          <vs-col vs-xs="12" vs-sm="2" vs-lg="2">
            <vs-input
              v-model="company.zip"
              class="w-full px-2"
              :label="$t('zip') | capitalize"
              disabled
            />
          </vs-col>
        </vs-row>
        <vs-row class="mt-2">
          <vs-row >
            <vs-col>
              <label class="px-3 "> {{ $t('account') }} </label>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
              <vs-select class="w-full px-2 mt-2" v-model="clientAccount" :clearable="false">
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="`${item.bank_name} - ${item.currency} - ${item.account}`"
                v-for="(item, index) in clientAccounts"
              />
            </vs-select>
            </vs-col>
          </vs-row>
        </vs-row>
      </div>

      <div v-for="expense in expenseList" :key="expense.id">
        <vs-divider color="primary" />
        <vs-row>
          <vs-col vs-xs="12" vs-sm="2" vs-lg="2">
            <vs-input
              :value="expense.id"
              class="w-full px-2"
              label="#"
              disabled
            />
          </vs-col>
          <vs-col vs-xs="12" vs-sm="10" vs-lg="10">
            <vs-input
              :value="expense.vendorName"
              class="w-full px-2"
              :label="$t('vendor') | capitalize"
              disabled
            />
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-xs="12" vs-sm="8" vs-lg="8">
            <vs-row>
              <vs-col>
                <label class="px-2"> {{ $t('account') }} </label>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col>
                <v-select
                  v-model="expense.account"
                  :options="filterAccounts(expense.vendorId)"
                  class="w-full px-2"
                  :reduce="(item) => item.id"
                  label="number"
                  :clearable="false"
                />
              </vs-col>
            </vs-row>
          </vs-col>
          <vs-col vs-xs="12" vs-sm="4" vs-lg="4">
            <vs-input
              :value="`$ ${formatNumber(expense.totalxml, 2)} ${
                expense.currency
              }`"
              class="w-full px-2"
              :label="$t('total') | capitalize"
              disabled
            />
          </vs-col>
        </vs-row>
      </div>
      <vs-divider />
      <vs-row>
        <vs-col vs-type="flex" vs-justify="end" vs-align="end" class="px-4">
          <span
            ><strong
              >{{ $t('total') | upperCase }} : $
              {{ formatNumber(this.total, 2) }}
            </strong></span
          >
        </vs-col>
      </vs-row>
    </div>
    <div class="mx-4" slot="footer">
      <vs-row>
        <vs-col vs-type="flex" vs-justify="end" vs-align="end" class="px-4">
          <vs-button
            color="primary"
            type="filled"
            class="mr-6"
            @click="generate"
            :disabled="disabledSubmit"
          >
            {{ $t('generate') | upperCase }}
          </vs-button>
          <vs-button color="primary" type="border" @click="close">
            {{ $t('close') | upperCase }}
          </vs-button>
        </vs-col>
      </vs-row>
    </div>
  </main-sidebar>
</template>

<script>
import MainSidebar from '@/views/components/MainSidebar.vue'
import vSelect from 'vue-select'
import loading from '@/mixins/Loading'
import InputDate from '@/components/custom/InputDate'
import request from '../request.js'
export default {
  components: {
    MainSidebar,
    'v-select': vSelect,
    InputDate,
  },
  computed: {
    isSidebarActive() {
      return this.$store.state.sidebar === this.name
    },
    isLoading() {
      return (
        this.loading.submit ||
        this.loading.company ||
        this.loading.client ||
        this.loading.accounts
      )
    },
    disabledSubmit() {
      return this.clientAccount === ''
    },
    total() {
      let total = 0
      this.expenses.forEach((i) => {
        total += Number(i.totalxml)
      })
      return total
    },
  },
  data: () => ({
    company: {},
    expenseList: [],
    accounts: [],
    clientAccounts: [],
    clientAccount: null,
    loading: {
      submit: false,
      company: false,
      client: false,
      accounts: false,
    },
  }),
  methods: {
    clear() {
      this.filter = Object.assign({}, this.defaultFilters)
    },
    close() {
      this.$store.dispatch('toggleSidebar', '')
    },
    getCompany() {
      this.loading.company = true
      const companyId = this.expenses[0].CompanyId
      request
        .getCompany(companyId)
        .then((response) => {
          this.company = response.data.company
          this.loading.company = false
        })
        .catch((response) => {
          this.loading.company = false
          this.showValidationErrors(response)
        })
    },
    filterAccounts(vendorId) {
      return this.accounts.filter((item) => {
        return item.VendorId === vendorId && item.number !== null
      })
    },
    getClientAccount() {
      this.loading.client = true
      const payload = {
        client: this.expenses[0].ClientId,
        currency: this.expenses[0].CurrencyId,
      }
      request
        .getClientAccount(payload)
        .then((response) => {
          this.clientAccounts = [...response.data.accounts]
          if(this.clientAccounts.length > 0){
            this.clientAccount = this.clientAccounts[0].id
          }
          this.loading.client = false
        })
        .catch((response) => {
          this.loading.client = false
          this.showValidationErrors(response)
        })
    },
    getAccounts() {
      this.loading.accounts = true
      const expenses = this.expenses.map((el) => el.ExpenseId)
      const payload = {
        expenses: expenses,
      }
      request
        .getAccounts(payload)
        .then((response) => {
          this.accounts = response.data.vendor_accounts
          this.loading.accounts = false
        })
        .catch((response) => {
          this.loading.accounts = false
          this.showValidationErrors(response)
        })
    },
    generate() {
      this.loading.submit = true
      
      // const accounts = this.expenseList.map((el) => ({
      //   ExpenseId: el.id,
      //   account: el.account,
      // }))
       const expenses = this.expenseList.map((el) => ({
        expense_id: el.id,
        vendor_account: el.account,
      }))
      const payload = {
        clientAccount:this.clientAccount,
        expenses: expenses,
        clientId: this.expenses[0].ClientId
      }
      request
        .generate(payload)
        .then((response) => {
          this.loading.submit = false
          this.$vs.notify({
            color: 'success',
            title: 'SUCCESS',
            text: 'Document Created',
          })
          this.$store.dispatch('toggleSidebar', '')
          this.$emit('success')
        })
        .catch((response) => {
          this.loading.submit = false
          this.showValidationErrors(response)
        })
    },

    init() {
      this.clientAccount = ''
      this.expenseList = [...this.expenses].map((el) => ({
        id: el.ExpenseId,
        currency: el.CurrencyId,
        totalxml: el.totalxml,
        vendorId: el.VendorId,
        vendorName: el.VendorName,
        account: '',
      }))
      this.getCompany()
      this.getAccounts()
      this.getClientAccount()
    },
  },
  mixins: [loading],
  props: {
    name: {
      type: String,
      required: true,
    },
    expenses: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading(`loading-${this.name}-sidebar`)
      } else {
        this.closeLoading(`loading-${this.name}-sidebar`)
      }
    },
    isSidebarActive(val) {
      if (val) {
        this.init()
      }
    },
  },
  mounted() {},
}
</script>

<style>
</style>
